class MediaMentionsSection {
  constructor(container) {
    this.container = container;
    this.swiperContainer = container.querySelector(".media-mentions__swiper");
    this.swiper = null;

    this.init();
  }

  init() {
    this.initSwiper();
    this.bindEvents();
  }

  initSwiper() {
    if (!this.swiperContainer) {
      return;
    }

    this.swiper = new Swiper(this.swiperContainer, {
      slidesPerView: 3,
      spaceBetween: 20,
      loop: false,
      centeredSlides: true,
      additionalSlides: 8,
      roundLengths: true,
      slidesOffsetBefore: 5,
      slidesOffsetAfter: 5,
      clickable: true,
      slideToClickedSlide: true,
      initialSlide: 1,
      pagination: {
        el: ".media-mentions__pagination",
        clickable: true,
        type: "bullets",
      },
      on: {
        init: () => {
          this.applyOpacityStates();
        },
        slideChange: () => {
          this.applyOpacityStates();
        },
      },
    });
  }

  applyOpacityStates() {
    if (!this.swiper) return;

    const slides = this.swiperContainer.querySelectorAll(".swiper-slide");
    const activeIndex = this.swiper.realIndex;

    const quoteItems = this.container.querySelectorAll(
      ".media-mentions__quote-item"
    );
    quoteItems.forEach((item, index) => {
      if (index === activeIndex) {
        item.style.opacity = "1";
        item.style.transition = "opacity 0.5s ease-in-out";
      } else {
        item.style.opacity = "0";
        item.style.transition = "opacity 0.3s ease-in-out";
      }
    });
  }

  logSlideWidths() {
    if (!this.swiper) return;

    const slides = this.swiperContainer.querySelectorAll(".swiper-slide");
    slides.forEach((slide, index) => {
      const computedWidth = getComputedStyle(slide).width;
    });
  }

  updateAccessibility() {
    if (!this.swiper) return;
    const slides = this.swiperContainer.querySelectorAll(".swiper-slide");
    slides.forEach((slide, index) => {
      const isActive = index === this.swiper.realIndex;
      slide.setAttribute("aria-hidden", !isActive);

      if (isActive) {
        slide.setAttribute("tabindex", "0");
      } else {
        slide.removeAttribute("tabindex");
      }
    });
  }

  bindEvents() {
    document.addEventListener(
      "shopify:section:load",
      this.handleSectionLoad.bind(this)
    );
    document.addEventListener(
      "shopify:section:unload",
      this.handleSectionUnload.bind(this)
    );
    this.container.addEventListener("mouseenter", () => {
      if (this.swiper && this.swiper.autoplay) {
        this.swiper.autoplay.pause();
      }
    });
    this.container.addEventListener("mouseleave", () => {
      if (this.swiper && this.swiper.autoplay) {
        this.swiper.autoplay.resume();
      }
    });
    document.addEventListener("visibilitychange", () => {
      if (this.swiper && this.swiper.autoplay) {
        if (document.hidden) {
          this.swiper.autoplay.pause();
        } else {
          this.swiper.autoplay.resume();
        }
      }
    });
  }

  handleSectionLoad(e) {
    if (e.detail.sectionId === this.container.getAttribute("data-section-id")) {
      this.destroy();
      setTimeout(() => {
        this.init();
      }, 100);
    }
  }

  handleSectionUnload(e) {
    if (e.detail.sectionId === this.container.getAttribute("data-section-id")) {
      this.destroy();
    }
  }

  destroy() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
  goToSlide(index) {
    if (this.swiper && index >= 0 && index < this.swiper.slides.length) {
      this.swiper.slideTo(index);
    }
  }

  getCurrentSlide() {
    return this.swiper ? this.swiper.realIndex : 0;
  }

  getTotalSlides() {
    return this.swiper ? this.swiper.slides.length : 0;
  }

  playAutoplay() {
    if (this.swiper && this.swiper.autoplay) {
      this.swiper.autoplay.start();
    }
  }

  pauseAutoplay() {
    if (this.swiper && this.swiper.autoplay) {
      this.swiper.autoplay.pause();
    }
  }

  refresh() {
    if (this.swiper) {
      this.swiper.update();
      this.updateAccessibility();
      this.logSlideWidths();
    }
  }
}
function initMediaMentionsSections() {
  const mediaMentionsSections = document.querySelectorAll(
    '[data-section-type="media-mentions"]'
  );

  mediaMentionsSections.forEach((section) => {
    if (!section.MediaMentionsInstance) {
      section.MediaMentionsInstance = new MediaMentionsSection(section);
    }
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    setTimeout(initMediaMentionsSections, 500);
  });
} else {
  setTimeout(initMediaMentionsSections, 500);
}
document.addEventListener("shopify:section:load", (e) => {
  if (e.target.querySelector('[data-section-type="media-mentions"]')) {
    if (checkSwiperAvailability()) {
      initMediaMentionsSections();
    }
  }
});

window.MediaMentionsSection = MediaMentionsSection;
